<template>
	<transition name="fade" @enter="onEnter" @leave="onLeave">
		<aside class="ly_aside">
			<div class="wrap">
				<div class="aside_header">
					<div class="tit_area">
						<router-link v-if="!isLoggedIn" to="/login" @click.native="close">
							<span class="txt">로그인해 주세요</span>
						</router-link>

						<span class="name" v-if="isLoggedIn">
							<i class="member_level" @click="onLevelClick">
								<!-- api에서 오는 값을 노출. gold/vip/plat -->
								<img :src="userInfo.companyLevelImageUrl2" :alt="`${levelText} Icon`" />
								<span class="txt_hidden">{{ levelText }}</span>
							</i>
							<strong>{{ companyName }}</strong
							>님
						</span>
					</div>

					<div class="btn_area">
						<!-- TODO: 챗봇 오픈 -->
						<!-- <button type="button" class="btn btn_chatbot">
              <i class="ico24_chatbot_d filter_w"></i>
              <span class="txt_hidden">쳇봇</span>
            </button> -->
						<button @click="close" type="button" class="btn btn_close">
							<i class="ico24_close_w"></i>
							<span class="txt_hidden">닫기</span>
						</button>
					</div>

					<!-- <span class="tooltip chat">고객상담 비즈봇입니다. 무엇을 도와드릴까요?</span> -->
				</div>

				<div class="aside_body" ref="wrapRef">
					<!-- 모바일 쿠폰 [비즈SHOP] -->
					<section>
						<h4 class="title"><span class="tit">모바일 쿠폰</span></h4>
						<div class="categoryWrap">
							<template v-for="category in popularCategoryList">
								<router-link
									class="unit"
									:to="{
										path: '/bizshop',
										query: {
											categorySeq: category.categorySeq,
										},
									}"
									:key="category.categorySeq"
									@click.native="close"
									data-tag-index="Menu"
									:data-tag-title="category.categoryName"
								>
									<img :src="category.categoryImg" />
									<span class="txt">{{ category.categoryName }}</span>
								</router-link>
							</template>
						</div>

						<div class="txt_r">
							<router-link class="btn btn_txt arrow" to="/bizshop" @click.native="close">
								<span class="txt sfont">전체 상품보기</span>
							</router-link>
						</div>

						<div class="btn_wrap">
							<router-link
								class="btn white"
								id="widthfull"
								to="/orderSend/apiintro"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="온라인 견적서"
							>
								<span class="txt">API 서비스</span>
							</router-link>
						</div>
					</section>

					<!-- 배너 영역 -->
					<GnbSection @click.native="close" />

					<section class="section_gray">
						<div class="btn_wrap">
							<router-link
								class="items"
								to="/specialprice"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="비즈특가"
							>
								<span class="txt">비즈특가</span>
							</router-link>
							<router-link
								class="items"
								to="/estimate/list"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="온라인 견적서"
							>
								<span class="txt">온라인 견적서</span>
							</router-link>
							<router-link
								class="items"
								to="/eventlist"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="이벤트"
							>
								<span class="txt">이벤트</span>
							</router-link>
							<router-link
								class="items"
								to="/allianceZone"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="혜택존"
							>
								<span class="txt">혜택존</span>
							</router-link>
						</div>
					</section>

					<!-- 주문발송 -->
					<!-- <section class="section_list">
            <h4 class="title"><span class="tit">주문발송</span></h4>
            <div class="list_wrap">
              <router-link class="items" to="/orderSend/cartSend" @click.native="close"
                  data-tag-index="Menu" data-tag-title="장바구니 발송">
                <span class="txt">장바구니 발송</span>
                <em class="badge" v-if="cartItemCount">{{ cartItemCount }}</em>
              </router-link>
              <router-link class="items" to="/orderSend/tempSend" @click.native="close"
                  data-tag-index="Menu" data-tag-title="임시저장 발송">
                <span class="txt">임시저장 발송</span>
                <em class="badge" v-if="orderTempCount">{{ orderTempCount }}</em>
              </router-link>
              <router-link class="items" to="/orderSend/apiintro" @click.native="close"
                  data-tag-index="Menu" data-tag-title="API 연동발송">
                <span class="txt">API 연동발송</span>
              </router-link>
            </div>
          </section> -->

					<DivisionLine />

					<!-- 판 촉 -->
					<section class="section_list">
						<h4 class="title"><span class="tit">판촉</span></h4>
						<div class="list_wrap">
							<router-link
								class="items"
								to="/panchok/orders"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="판촉 시안 확인"
							>
								<span class="txt">판촉 시안 확인</span>
							</router-link>
						</div>
					</section>

					<DivisionLine />

					<!--설문조사-->
					<section class="section_list">
						<h4 class="title"><span class="tit">설문조사</span></h4>
						<div class="list_wrap">
							<!--
              <router-link class="items" to="/survey/serviceinfo" @click.native="close"
                  data-tag-index="Menu" data-tag-title="설문조사 안내">
                <span class="txt">설문조사 안내</span>
              </router-link>
              -->
							<!--
              <router-link class="items" to="/survey/defaultsend" @click.native="close">
                <span class="txt">일반형 발송</span>
              </router-link>
              <router-link class="items" to="/survey/lotterysend" @click.native="close"
                  data-tag-index="Menu" data-tag-title="추첨형 발송">
                <span class="txt">추첨형 발송</span>
              </router-link>
              -->
							<router-link
								class="items"
								to="/survey/statistics"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="설문 내역·통계"
							>
								<span class="txt">설문 내역·통계</span>
							</router-link>
						</div>
					</section>

					<DivisionLine />

					<!-- 문자메시지 -->
					<section class="section_list">
						<h4 class="title"><span class="tit">문자메시지</span></h4>
						<div class="list_wrap">
							<!--
              <router-link class="items" to="/msgsvc/serviceInfo" @click.native="close">
                <span class="txt">문자메시지 서비스 안내</span>
              </router-link>
              -->
							<router-link class="items" to="/msgsvc/sendMng" @click.native="close">
								<span class="txt">발송관리</span>
							</router-link>
						</div>
					</section>

					<DivisionLine />

					<!-- 기업고객센터 -->
					<section class="section_list">
						<h4 class="title"><span class="tit">고객센터</span></h4>
						<div class="list_wrap">
							<router-link
								class="items"
								to="/giftishow"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="공지사항"
							>
								<span class="txt">서비스 소개</span>
							</router-link>

							<!-- 2023.07.17 서비스 가이드 버튼 주석처리 gs.song -->
							<!-- <router-link
								class="items"
								to="/bizguide"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="공지사항"
							>
								<span class="txt">서비스 가이드</span>
							</router-link> -->
							<router-link
								class="items"
								to="/serviceguidelist"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="서비스 활용 TIP"
							>
								<span class="txt">서비스 활용 TIP</span>
							</router-link>
							<router-link
								class="items"
								to="/notice"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="공지사항"
							>
								<span class="txt">공지사항</span>
							</router-link>
							<router-link
								class="items"
								to="/faq"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="자주하는 질문"
							>
								<span class="txt">자주하는 질문</span>
							</router-link>
							<router-link
								class="items"
								:to="{ name: 'qna', params: { tp: 'ALL' } }"
								@click.native="close"
								data-tag-index="Menu"
								data-tag-title="1:1문의"
							>
								<span class="txt">1:1문의</span>
							</router-link>
						</div>
					</section>

					<DivisionLine />

					<!-- 하단 로그아웃/고객센터 전화번호 -->
					<section class="section_footer">
						<a class="unit customer" href="tel:1588-0108">고객센터 1588-0108</a>
						<button class="unit" type="button" v-if="isLoggedIn" @click="doLogout()">
							<span class="txt">로그아웃</span>
						</button>
						<a class="unit" href="https://biz.giftishow.com?screenMode=PC" target="_blank">PC버전</a>
					</section>
				</div>
			</div>
		</aside>
	</transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import DivisionLine from '@/components/common/Sections/DivisionLine.vue';
import GnbSection from '@/components/home/GnbSection/GnbSection.vue';
import alarmMsg from '@/utils/alarmMsg';
import { unref } from '@vue/composition-api';

export default {
	components: {
		DivisionLine,
		GnbSection,
	},

	methods: {
		...mapActions(['updateUserInfo']),
		close() {
			this.$emit('close');
		},
		onEnter() {
			this.updateUserInfo();
			disableBodyScroll(this.$refs.wrapRef);
		},
		onLeave() {
			this.$refs.wrapRef.scrollTo(0, 0);
			enableBodyScroll(this.$refs.wrapRef);
		},
		onLevelClick() {
			// this.$router.push('/mybiz/bizmain');
			// 로그인 후 /mybiz/bizmain 화면에서 클릭시 문제 수정
			if (this.$route.path == '/mybiz/bizmain') {
				this.close();
			} else {
				this.$router.push('/mybiz/bizmain');
			}
		},
		/**
		 * 로그아웃
		 */
		doLogout() {
			if (!this.isLoggedIn) return false;
			try {
				this.$store.dispatch('Logout');
			} catch (error) {
				alarmMsg.showMsg('로그아웃 시도하는 도중에 실패하였습니다.');
			}
		},
	},

	computed: {
		...mapGetters(['popularCategoryList', 'brandMap', 'cartItemCount', 'isLoggedIn', 'userInfo']),

		/** 회사명 */
		companyName() {
			return this.userInfo.companyName;
		},

		/** 회원등급 */
		levelText() {
			return this.userInfo.companyLevelCd;
		},

		/**
		 * 회원등급 html class명
		 * @var
		 * gold: 골드
		 * @var
		 * vip: vip
		 * @var
		 * plat: 플래티넘
		 * @var
		 * spec: Special
		 */

		/**
		 * 스페셜 등급 여부
		 * @description
		 * 'GOLD', 'VIP', 'PLATINUM' 등급이 아닌 경우 스페셜
		 */
		isSpecialLevel() {
			if (!this.userInfo.companyLevelCd) return false;
			return !/^(GOLD|VIP|PLATINUM)$/i.test(this.userInfo?.companyLevelCd);
		},

		/** 임시저장 항목 수 */
		orderTempCount() {
			return this.userInfo?.orderTempCount || 0;
		},
	},
};
</script>

<style lang="less" scoped>
#widthfull {
	width: 100%;
}

.ico-gnb-new {
	position: relative;
	&:before {
		content: '';
		display: inline-block;
		position: absolute;
		top: 2px;
		right: -20px;
		width: 16px;
		height: 16px;
		vertical-align: top;
		background: url('~@/assets/image/icon/ico_gnb_new@2x.png') 0 0 no-repeat;
		background-size: 16px 16px;
	}
}
</style>
